import React from "react";
import PropTypes from "prop-types";
import SVG from "theme/components/icons/base/SVG";

const VideoPlayIcon = ({ color, ...props }) => (
    <SVG fill="none" {...props}>
        <rect width="30" height="20.2454" rx="7.08661" fill="#4D4D4D" fillOpacity="0.94" />
        <path
            d="M11.7793 13.3231V7.00665C11.7793 6.65922 12.1417 6.43063 12.4552 6.58028L18.9946 9.70134C19.3514 9.87162 19.3537 10.3786 18.9985 10.5522L12.4592 13.7476C12.1453 13.9009 11.7793 13.6724 11.7793 13.3231Z"
            fill="white"
        />
    </SVG>
);

VideoPlayIcon.propTypes = {
    color: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    viewBox: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};

VideoPlayIcon.defaultProps = {
    color: "#FFFFFF",
    height: "21px",
    viewBox: "0 0 30 21",
    width: "30px",
};

export default VideoPlayIcon;
